import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the view for partners' products table.
 * @extends JetView
 */
export default class tablePartnersProductsView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters

        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader
                    cols: [
                        {
                            view: 'datatable', // DataTable view
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            id: 'datatable', // ID for the datatable
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                {
                                    id: 'rating', // Column ID
                                    header: '', // Column header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    template: function (obj) {
                                        // Template function for rendering
                                        if (devConfig.getPermAction('partnersProvidersEdit', 'Edit')) {
                                            return "<span class='webix_icon wxi-close edit'></span>"; // Edit icon if permission granted
                                        } else {
                                            return ''; // No icon if permission denied
                                        }
                                    },
                                },
                                {
                                    id: 'Id', // Column ID
                                    header: 'Id', // Column header
                                    width: 50, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Provider', // Column ID
                                    header: _('Proveedor'), // Localized column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Partner', // Column ID
                                    header: _('Partner'), // Localized column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'State', // Column ID
                                    header: _('Estado'), // Localized column header
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Activado') },
                                        { id: 'I', value: _('Inactivado') },
                                    ],
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'isVerify', // Column ID
                                    header: _('Verificado'), // Localized column header
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Activado') },
                                        { id: 'I', value: _('Inactivado') },
                                    ],
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'filterCountry', // Column ID
                                    header: _('Filtro País'), // Localized column header
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Activado') },
                                        { id: 'I', value: _('Inactivado') },
                                    ],
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Maximum', // Column ID
                                    header: _('Máximo'), // Localized column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Minimum', // Column ID
                                    header: _('Mínimo'), // Localized column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'BonusSystem', // Column ID
                                    header: _('Bonus System'), // Localized column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    template: function (obj) {
                                        // Template function for rendering
                                        return obj.BonusSystem == true || obj.BonusSystem == 'S'
                                            ? 'S' // Display 'S' if BonusSystem is true
                                            : 'N'; // Display 'N' otherwise
                                    },
                                },
                                {
                                    id: 'TestUsers', // Column ID
                                    header: _('Test Users'), // Localized column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    template: function (obj) {
                                        // Template function for rendering
                                        return obj.TestUsers == true || obj.TestUsers == 'S'
                                            ? 'S' // Display 'S' if TestUsers is true
                                            : 'N'; // Display 'N' otherwise
                                    },
                                },
                                {
                                    id: 'Detail', // Column ID
                                    header: _('Detalle'), // Localized column header
                                    width: 280, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Image', // Column ID
                                    header: _('Imagen'), // Localized column header
                                    width: 570, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                // Event handler for item click
                                edit: function (euv, id) {
                                    $$('editwinPartnerSubProviders').show(); // Show edit window
                                    var item = this.getItem(id); // Get the clicked item
                                    // Convert BonusSystem to boolean
                                    if (item.BonusSystem == 'S' || item.BonusSystem == true) {
                                        item.BonusSystem = true;
                                    } else {
                                        item.BonusSystem = false;
                                    }
                                    // Convert TestUsers to boolean
                                    if (item.TestUsers == 'S' || item.TestUsers == true) {
                                        item.TestUsers = true;
                                    } else {
                                        item.TestUsers = false;
                                    }
                                    $$('editformSubProviders').setValues(item); // Set values in the edit form
                                },
                            },
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // Pager ID
                            // Data source URL
                            url:
                                devConfig.geturlApi() +
                                'PartnersSubProviders/GetPartnersSubProviders?Partner=' +
                                id_partner +
                                '&',
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        grid = $$('datatable'); // Reference to the datatable
        var url = grid.data.url; // Data source URL
        var cthis = this; // Reference to the current context
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters
        var providers = []; // Array to hold providers
        var popup = webix.ui({
            // Popup window for editing partner sub-providers
            view: 'window',
            id: 'editwinPartnerSubProviders', // ID for the edit window (unique to this view to avoid clashing with sibling tabs' popups)
            width: screen.width < 500 ? 350 : 450, // Width based on screen size
            height: screen.width < 500 ? 680 : 580, // Height based on screen size
            fullscreen: screen.width < 500 ? true : false, // Fullscreen mode based on screen size
            head: {
                view: 'toolbar', // Toolbar for the window header
                cols: [
                    { view: 'label', label: _('Editar Partner') }, // Label for editing partner
                    {
                        view: 'icon', // Close icon
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Hide the window on click
                        },
                    },
                ],
            },
            position: 'center', // Center the window
            modal: true, // Non-modal window
            body: {
                view: 'scrollview', // Scrollable view
                scroll: 'y', // Vertical scrolling
                body: {
                    view: 'form', // Form for editing partner details
                    id: 'editformSubProviders', // ID for the edit form (unique to this view)
                    scroll: 'y', // Vertical scrolling
                    width: screen.width < 500 ? 350 : 450, // Width based on screen size
                    height: screen.width < 500 ? 680 : 530, // Height based on screen size
                    elements: [
                        // Form elements
                        {
                            view: 'text', // Text input for ID
                            label: 'Id',
                            name: 'Id',
                            readonly: true, // Read-only field
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            view: 'text', // Text input for Provider
                            label: _('Proveedor'),
                            name: 'Provider',
                            readonly: true, // Read-only field
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            view: 'combo', // Combo box for State
                            label: _('Estado'),
                            name: 'State',
                            options: [
                                // Options for the combo box
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            view: 'combo', // Combo box for isVerify
                            label: _('Verificado'),
                            name: 'isVerify',
                            options: [
                                // Options for the combo box
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            view: 'combo', // Combo box for filterCountry
                            label: _('Filtro País'),
                            name: 'filterCountry',
                            options: [
                                // Options for the combo box
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            view: 'text', // Text input for Maximum
                            label: _('Máximo'),
                            name: 'Maximum',
                            attributes: { type: 'number' }, // Input type
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            view: 'text', // Text input for Minimum
                            label: _('Mínimo'),
                            name: 'Minimum',
                            attributes: { type: 'number' }, // Input type
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            view: 'text', // Text input for Detail
                            label: _('Detalle'),
                            name: 'Detail',
                            readonly: false, // Editable field
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            view: 'text', // Text input for Image
                            label: _('Imagen'),
                            name: 'Image',
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            view: 'checkbox', // Checkbox for Bonus System
                            label: _('Bonus System'),
                            labelPosition: 'top', // Label position
                            labelWidth: 90, // Label width
                            name: 'BonusSystem',
                            value: false, // Default value
                            minWidth: 200, // Minimum width
                            checkValue: true, // Value when checked
                            uncheckValue: false, // Value when unchecked
                        },
                        {
                            view: 'checkbox', // Checkbox for Test Users
                            label: _('Usuarios de Pruebas'),
                            labelPosition: 'top', // Label position
                            labelWidth: 90, // Label width
                            name: 'TestUsers',
                            value: false, // Default value
                            minWidth: 200, // Minimum width
                            checkValue: true, // Value when checked
                            uncheckValue: false, // Value when unchecked
                        },
                        {
                            margin: 10, // Margin for the next element
                            cols: [
                                {
                                    view: 'text', // Text input for Note
                                    labelPosition: 'top', // Label position
                                    label: _('Explicación'),
                                    name: 'Note',
                                    labelWidth: 160, // Label width
                                    attributes: { type: 'text' }, // Input type
                                },
                            ],
                        },
                        {
                            cols: [
                                // Button row
                                {
                                    view: 'button', // Cancel button
                                    value: _('Cancelar'),
                                    click: function () {
                                        this.getTopParentView().hide(); // Hide the window on click
                                    },
                                },
                                {
                                    view: 'button', // Save button
                                    type: 'form',
                                    value: _('Guardar'),
                                    click: function ($e) {
                                        var values = $$('editformSubProviders').getValues(); // Get form values
                                        var c2this = this; // Reference to the current context
                                        values.Partner = id_partner; // Add partner ID to values
                                        webix
                                            .ajax() // AJAX request to save data
                                            .headers({
                                                'Content-type': 'application/json', // Set content type
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'PartnersSubProviders/UpdatePartnerSubProvider',
                                                values, // Data to send
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Error! ', // Error message
                                                        );
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        text = JSON.parse(text); // Parse response
                                                        if (text.HasError) {
                                                            webix.message(
                                                                'Error: ' + text.AlertMessage, // Display error message
                                                            );
                                                        } else {
                                                            $$('editformSubProviders').clear(); // Clear form
                                                            c2this.getTopParentView().hide(); // Hide the window
                                                            webix.message(
                                                                'Sub Proveedor Partner Editado', // Success message
                                                            );
                                                        }
                                                    },
                                                },
                                            );
                                    },
                                },
                            ],
                        },
                    ],
                },
            },
        });
        this.editWin = popup; // Keep reference for cleanup on destroy()
        var popupAdd = webix.ui({
            // Popup window for adding partner sub-providers
            view: 'window',
            id: 'AddPartnerSubProviders', // ID for the add window (unique to this view to avoid clashing with sibling tabs' popups)
            width: screen.width < 500 ? 350 : 450, // Width based on screen size
            height: screen.width < 500 ? 450 : 450, // Height based on screen size
            fullscreen: screen.width < 500 ? true : false, // Fullscreen mode based on screen size
            head: {
                view: 'toolbar', // Toolbar for the window header
                cols: [
                    { view: 'label', label: _('Añadir Proveedor Partner') }, // Label for adding partner
                    {
                        view: 'icon', // Close icon
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Hide the window on click
                        },
                    },
                ],
            },
            position: 'center', // Center the window
            modal: true, // Modal window
            body: {
                view: 'scrollview', // Scrollable view
                scroll: 'y', // Vertical scrolling
                body: {
                    view: 'form', // Form for adding partner details
                    id: 'addformSubProviders', // ID for the add form (unique to this view)
                    width: screen.width < 500 ? 350 : 450, // Width based on screen size
                    height: screen.width < 500 ? 450 : 400, // Height based on screen size
                    elements: [
                        // Form elements
                        {
                            view: 'combo', // Combo box for Provider
                            label: _('Proveedores'),
                            name: 'Provider',
                            id: 'AddProviderSubProviders', // ID for the provider combo (unique to this view)
                            options: providers, // Options for the combo
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            view: 'combo', // Combo box for State
                            label: _('Estado'),
                            name: 'State',
                            value: 'A', // Default value
                            options: [
                                // Options for the combo box
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            view: 'combo', // Combo box for isVerify
                            label: _('Verificado'),
                            name: 'isVerify',
                            value: 'I', // Default value
                            options: [
                                // Options for the combo box
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            view: 'combo', // Combo box for filterCountry
                            label: _('Filtro País'),
                            name: 'filterCountry',
                            value: 'I', // Default value
                            options: [
                                // Options for the combo box
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            view: 'text', // Text input for Maximum
                            label: _('Máximo'),
                            name: 'Maximum',
                            value: 0, // Default value
                            attributes: { type: 'number' }, // Input type
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            view: 'text', // Text input for Minimum
                            label: _('Mínimo'),
                            name: 'Minimum',
                            value: 0, // Default value
                            attributes: { type: 'number' }, // Input type
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            view: 'text', // Text input for Image
                            label: _('Imagen'),
                            name: 'Image',
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 150, // Label width
                        },
                        {
                            view: 'text', // Text input for Detail
                            label: _('Detalles'),
                            name: 'Detail',
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 90, // Label width
                        },
                        {
                            cols: [
                                // Button row
                                {
                                    view: 'button', // Cancel button
                                    value: _('Cancelar'),
                                    click: function () {
                                        this.getTopParentView().hide(); // Hide the window on click
                                        $$('addformSubProviders').clear(); // Clear the form
                                    },
                                },
                                {
                                    view: 'button', // Save button
                                    type: 'form',
                                    value: _('Guardar'),
                                    click: function ($e) {
                                        var values = $$('addformSubProviders').getValues(); // Get form values
                                        values.Partner = id_partner; // Add partner ID to values
                                        var c2this = this; // Reference to the current context
                                        webix
                                            .ajax() // AJAX request to save data
                                            .headers({
                                                'Content-type': 'application/json', // Set content type
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'PartnerSubProvider/CreatePartnerProvider',
                                                values, // Data to send
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Error! ', // Error message
                                                        );
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        text = JSON.parse(text); // Parse response
                                                        if (text.HasError) {
                                                            webix.message(
                                                                'Error: ' + text.AlertMessage, // Display error message
                                                            );
                                                        } else {
                                                            $$('addformSubProviders').clear(); // Clear form
                                                            c2this.getTopParentView().hide(); // Hide the window
                                                            webix.message(
                                                                'Sub Proveedor Partner Agregado', // Success message
                                                            );
                                                        }
                                                    },
                                                },
                                            );
                                    },
                                },
                            ],
                        },
                    ],
                },
            },
        });
        this.addWin = popupAdd; // Keep reference for cleanup on destroy()
        this.on(this.app, 'addProductPartner:button', (filter) => {
            popupAdd.show(); // Show add window
            var optionsCountries = $$('AddProviderSubProviders').getList(); // Get provider options
            optionsCountries.clearAll(); // Clear existing options
            optionsCountries.parse(providers); // Parse new options
        });
        var filter = ''; // Initialize filter variable
        this.on(this.app, 'partnerSubProvider:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Convert to date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Convert to date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&Partner=' + id_partner; // Add partner ID to query
            grid.clearAll(); // Clear grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load data with filters
            filter = string1; // Update filter variable
        });
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Event handler for sorting
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event handler for item click
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });
        this.on(this.app, 'player:select', (Id) => {
            // Event handler for player selection
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data for selected player
            );
        });
        grid.attachEvent('onItemDblClick', function (id, e, node) {
            // Event handler for double click
            var item = this.getItem(id); // Get clicked item
            popup.show(); // Show edit popup
        });
        $$('editformSubProviders').bind($$('datatable')); // Bind edit form to datatable
        webix
            .ajax() // AJAX request to fetch providers
            .headers({
                'Content-type': 'application/json', // Set content type
            })
            .post(devConfig.geturlApi() + 'Providers/GetProductProviders', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Error message
                },
                success: function (text, data, XmlHttpRequest) {
                    var data = JSON.parse(
                        text
                            .replace(/"Id"/g, '"id"') // Normalize ID field
                            .replace(/"Name"/g, '"value"'), // Normalize Name field
                    );
                    console.log(data); // Log fetched data
                    providers = data.Data; // Store providers data
                },
            });
    }

    /**
     * Destroys the popups created in init() so they don't leak into Webix's
     * global component registry once this view is left (they are not part
     * of the tree returned by config(), so Jet does not clean them up automatically).
     */
    destroy() {
        if (this.editWin) {
            this.editWin.destructor();
        }
        if (this.addWin) {
            this.addWin.destructor();
        }
    }
}

// FILE DOCUMENTED
